import { Col, Divider, Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import FormField from '../FormField';
import CustomInputField from '../../atoms/CustomInputField';
import CustomButton from '../../atoms/CustomButton';
import CustomSelectBox from '../../atoms/CustomSelectBox';
import CustomTextArea from '../../atoms/CustomTextArea';
import PaymentSummary from '../PaymentSummary';
import { paymentType, paymentStatus, transStatus } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { sales } from '../../redux/slice/sales/salesSlice';

const MakePaymentForm = (props) => {
  const {
    subTotal,
    total,
    taxAmount,
    discountAmount,
    recordList,
    discountType,
    handlePaymentModalClose,
    setPrintModalOpen,
    setRecordList,
    warehouseId,
  } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [invoice, setInvoice] = useState(false);

  const salesState = useSelector((state) => state.salesState);

  // Load data into form when recordList changes
  useEffect(() => {
    if (recordList) {
      form.setFieldsValue({
        receivedAmount: total || '',
        payingAmount: total || '',
        changeReturn: recordList.changeReturn || '0.00',
        paymentType: 'Cash',
        note: '',
        paymentStatus: 'paid',
      });
    }
  }, [recordList, form]);

  console.log(form.getFieldValue('paymentType'));

  const generatePONumber = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `PO-${year}${month}${day}-${hours}${minutes}${seconds}-${milliseconds}`;
  };

  const handleFormSubmit = (values) => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString();

    const payload = {
      salesLines: recordList,
      subTotal: subTotal,
      totalTax: taxAmount,
      discountType: discountType,
      discountAmount: discountAmount,
      paymentStatus: values.paymentStatus,
      paymentType: values.paymentType,
      note: values.note,
      batchId: '1',
      SalesTransNo: generatePONumber(),
      ShiftID: '123',
      TransStatus: values.transStatus,
      salesHDR_ID: '0',
      sgstAmount: '0.0',
      cgstAmount: '0.0',
      igstAmount: '0.0',
      createdOn: formattedDate,
      modifiedOn: formattedDate,
      warehouseID: warehouseId,
      customerID: '1',
      companyId: '1',
      terminalID: '1',
      cardAmount: values.paymentType === 'Card' ? total : 0,
      CardLast4Digits: values.paymentType === 'Card' ? '1234' : '',
      upiAmount: values.paymentType === 'Upi' ? total : 0,
      UPIID: values.paymentType === 'Upi' ? 'ayush.chourasiya@ybl' : '',
      cashAmount: ['Cash', 'Bank_transfer', 'Cheque', 'Other'].includes(values.paymentType) ? total : 0,
    };
    console.log(payload, 'payload');

    dispatch(sales(payload));

    // categoryIdin perticularline
    // isReturn : false should be add in lineItems
    //batchId:"123" shoul not be null in line
  };

  useEffect(() => {
    if (salesState.status === 'success') {
      handlePaymentModalClose();
      setRecordList([]);
      if (invoice) {
        setPrintModalOpen(true);
      }
    }
  }, [salesState.status]);

  return (
    <>
      <>
        <Form
          layout='vertical'
          name='make_payment_form'
          form={form}
          initialValues={{
            receivedAmount: '',
            payingAmount: '',
            changeReturn: '',
            paymentType: '',
            note: '',
            paymentStatus: '',
          }}
          onFinish={handleFormSubmit} // Add submit handler
        >
          <Row gutter={12}>
            <Col span={16}>
              <Row gutter={[8, 8]}>
                <Col span={12}>
                  <FormField label='Received Amount' name='receivedAmount'>
                    <CustomInputField type='text' placeholder='Received Amount' size='large' />
                  </FormField>
                </Col>
                <Col span={12}>
                  <FormField label='Paying Amount' name='payingAmount'>
                    <CustomInputField disabled type='text' placeholder='Paying Amount' size='large' />
                  </FormField>
                </Col>
                <Col span={12}>
                  <FormField label='Change Return' name='changeReturn'>
                    <CustomInputField disabled type='text' placeholder='Change Return' size='large' />
                  </FormField>
                </Col>

                <Col span={12}>
                  <FormField label='Payment Type' name='paymentType'>
                    <CustomSelectBox
                      size='large'
                      showSearch
                      placeholder='Select a payment type'
                      options={paymentType}
                    />
                  </FormField>
                </Col>
                <Col span={24}>
                  <FormField label='Note' name='note'>
                    <CustomTextArea rows={3} placeholder='Enter Note' size='large' />
                  </FormField>
                </Col>
                <Col span={24}>
                  <FormField label='Payment Status' name='paymentStatus'>
                    <CustomSelectBox
                      size='large'
                      showSearch
                      placeholder='Select payment status'
                      options={paymentStatus}
                    />
                  </FormField>
                </Col>
                <Col span={24}>
                  <FormField label='Trans Status' name='transStatus'>
                    <CustomSelectBox
                      size='large'
                      showSearch
                      placeholder='Select payment status'
                      options={transStatus}
                    />
                  </FormField>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <div style={{ padding: '0px 0', height: '80%', display: 'flex', alignItems: 'center' }}>
                <PaymentSummary
                  subTotal={subTotal}
                  total={total}
                  taxAmount={taxAmount}
                  discountAmount={discountAmount}
                  recordList={recordList}
                />
              </div>
            </Col>
          </Row>

          <Divider style={{ margin: '12px 0' }} />

          {/* Form Buttons */}
          <Row gutter={[16, 16]} style={{ justifyContent: 'flex-end', marginBottom: 0 }}>
            <Col span={4}>
              <CustomButton
                type='primary'
                htmlType='submit'
                size='large'
                block
                loading={!invoice && salesState.status === 'loading'}
              >
                Submit
              </CustomButton>
            </Col>
            <Col span={4}>
              <CustomButton
                type='primary'
                size='large'
                block
                onClick={() => {
                  form.submit(); // Trigger form submission to get form values
                  setInvoice(true);
                }}
                loading={invoice && salesState.status === 'loading'}
              >
                Submit & Print
              </CustomButton>
            </Col>
            <Col span={4}>
              <CustomButton type='default' size='large' block>
                Cancel
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </>
    </>
  );
};

export default MakePaymentForm;
